import { createSelector } from '@reduxjs/toolkit';
import { MerchantPortalState } from '../initialState';

const getDeal = (state: MerchantPortalState) => state.isoPortal.deal;
const getDealRequiredStips = (state: MerchantPortalState) => state.isoPortal.requiredStips;
const getDealCalc = (state: MerchantPortalState) => state.isoPortal.dealCalc;
const getOfferProperties = (state: MerchantPortalState) => state.isoPortal.offerProperties;
const getApprovals = (state: MerchantPortalState) => state.isoPortal.approvals;
const getDealDocuments = (state: MerchantPortalState) => state.isoPortal.documents;
const getRequestContractProperties = (state: MerchantPortalState) =>
  state.isoPortal.requestContractProperties;
const getContract = (state: MerchantPortalState) => state.isoPortal.contract;

export const getDealSelector = createSelector(getDeal, (deal) => deal);
export const getDealRequiredStipsSelector = createSelector(
  getDealRequiredStips,
  (dealRequiredStips) => dealRequiredStips
);
export const getDealCalcSelector = createSelector(getDealCalc, (dealCalc) => dealCalc);
export const getOfferPropertiesSelector = createSelector(
  getOfferProperties,
  (offerProperties) => offerProperties
);
export const getApprovalsSelector = createSelector(getApprovals, (approvals) => approvals || []);
export const getDocumentsCountSelector = createSelector(
  getDealDocuments,
  // @ts-ignore
  (documents) => Object.keys(documents)?.filter((x) => !!documents[x])?.length ?? 0
);
export const getDealDocumentsSelector = createSelector(
  getDealDocuments,
  // @ts-ignore
  (dealDocuments) => dealDocuments
);
export const getRequestContractPropertiesSelector = createSelector(
  getRequestContractProperties,
  (requestContractProperties) => requestContractProperties
);

export const getContractSelector = createSelector(getContract, (contract) => contract);

// Get all submitted applications for the ISO
export const getIsoSubmittedApplicationsSelector = (state: any) =>
  state.isoPortal.submittedApplications || {
    data: [],
    total: 0,
    pageNumber: 1,
    pageSize: 10,
  };

// Get submitted applications loading progress
export const getIsoSubmittedApplicationsLoadingProgressSelector = (state: any) =>
  state.isoPortal.submittedApplicationsLoadingProgress || {
    currentPage: 0,
    totalPages: 0,
    loadedRecords: 0,
  };

// Get submitted applications statistics for pie chart
export const getIsoSubmittedApplicationsStatisticsSelector = createSelector(
  getIsoSubmittedApplicationsSelector,
  (submittedApplicationsData) => {
    const applications = submittedApplicationsData.data || [];

    // Count applications by status
    const statusCounts: Record<string, number> = {};

    applications.forEach((app: any) => {
      const status = app.statusName || 'Unknown';
      statusCounts[status] = (statusCounts[status] || 0) + 1;
    });

    return statusCounts;
  }
);

// Get all funded deals for the ISO
export const getIsoFundedDealsSelector = (state: any) =>
  state.isoPortal.fundedDeals || {
    data: [],
    total: 0,
    pageNumber: 1,
    pageSize: 10,
  };

// Get funded deals loading progress
export const getIsoFundedDealsLoadingProgressSelector = (state: any) =>
  state.isoPortal.fundedDealsLoadingProgress || {
    currentPage: 0,
    totalPages: 0,
    loadedRecords: 0,
  };
